import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findUserInfo = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user/token`,
        method: 'GET'
    })
}

export const getUserSystems = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user/systems`,
        method: 'GET'
    })
}

export const findUsersByUserType = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsers?`+params,
        method: 'GET'
    })
}

export const getUserMenus = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user/menus`,
        method: 'GET'
    })
}

export const getUserPermissions = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user/permissions`,
        method: 'GET'
    })
}

export const findUser = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user?`+params,
        method: 'GET'
    })
}

export const addUser = (data) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user`,
        method: 'POST',
        data: data
    })
}

export const editUser = (data) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user`,
        method: 'PUT',
        data: data
    })
}

export const delUser = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-basic/v1/user/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}